import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
interface AppConfig {
  redirectUrl: string;
}
@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: AppConfig | null = null;
  private configLoadPromise: Promise<void> | null = null;

  constructor(private http: HttpClient) {}
  
  loadConfig(): Promise<void> {
  // Return existing promise if config is already being loaded
    if (this.configLoadPromise) {
      return this.configLoadPromise;
    }
    this.configLoadPromise = this.http
      .get<AppConfig>('/assets/config.json')
      .toPromise()
      .then(config => {
        this.config = config;
      });
      
    return this.configLoadPromise;
  }
  
  get redirectUrl(): string {
    return this.config?.redirectUrl || '';
  }
}
